import { FC } from "react";
import { Modal } from "../../layout/Modal";
import { ModalItemWithHeader } from "../../layout/ModalItemWithHeader";
import { Button } from "../Button";

export type PeriodReviewedModalProps = {
	reviewFn?: () => void;
	unreviewFn?: () => void;
	onClose: () => void;
};

export const PeriodReviewedModal: FC<PeriodReviewedModalProps> = ({
	reviewFn,
	unreviewFn,
	onClose,
}) => {
	const isReview = Boolean(reviewFn);

	const handleSubmit = () => {
		if (isReview) {
			reviewFn?.();
		} else {
			unreviewFn?.();
		}
		onClose();
	};

	return (
		<Modal onClickOutside={onClose}>
			<ModalItemWithHeader
				header={isReview ? "Mark Period as Reviewed" : "Unmark Period as Reviewed"}
				onClose={onClose}
			>
				<div className="flex flex-col max-w-[600px] pt-4 pb-8 px-8 max-h-[550px]">
					<div className="flex flex-col gap-4 py-2">
						<div
							data-testid="review-modal-instructions"
							className="flex flex-col shrink-0 h-fit text-sm text-secondary items-start justify-start gap-2"
						>
							{isReview ? (
								<div>
									Marking a period as reviewed signals that you have verified or corrected the line
									items. You can always unmark it later if you need to make further edits.
								</div>
							) : (
								<div>
									This period has been marked as reviewed. Would you like to unmark it so it can be
									edited?
								</div>
							)}
						</div>
					</div>
					<div className="flex flex-row-reverse items-center justify-start gap-2 mt-6">
						<Button
							testId="submit-button"
							className="order-1"
							color="primary"
							onClick={handleSubmit}
							filled
						>
							{isReview ? "Mark as Reviewed" : "Unmark as Reviewed"}
						</Button>
						<Button testId="cancel-button" className="order-2" color="secondary" onClick={onClose}>
							Cancel
						</Button>
					</div>
				</div>
			</ModalItemWithHeader>
		</Modal>
	);
};
